import { Button, Typography } from 'antd';

import styled from '@emotion/styled';

export const Title = styled(Typography.Title)`
  &.ui-typography {
    margin-bottom: 0;
  }
`;

export const DeleteTaxButton = styled(Button)`
  margin-right: auto;
`;

export const ThreeColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const FormGroup = styled.fieldset`
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.bgGrey};
  border-radius: 8px;
  margin-bottom: 12px;
`;